const BILLING_EVENT_NAME = 'eventory:billing-event';
const PAYMENT_SUCCESS_EVENT_NAME = 'eventory:payment-success';

const dispatchBillingEvent = (detail) => {
	if (typeof window === 'undefined') return;
	window.dispatchEvent(new CustomEvent(BILLING_EVENT_NAME, { detail }));
};

const dispatchPaymentSuccess = (detail) => {
	if (typeof window === 'undefined') return;
	window.dispatchEvent(new CustomEvent(PAYMENT_SUCCESS_EVENT_NAME, { detail }));
};

const subscribeToBillingEvents = (callback) => {
	if (typeof window === 'undefined') return () => {};
	const handler = (event) => callback(event.detail);
	window.addEventListener(BILLING_EVENT_NAME, handler);
	return () => window.removeEventListener(BILLING_EVENT_NAME, handler);
};

const subscribeToPaymentSuccess = (callback) => {
	if (typeof window === 'undefined') return () => {};
	const handler = (event) => callback(event.detail);
	window.addEventListener(PAYMENT_SUCCESS_EVENT_NAME, handler);
	return () => window.removeEventListener(PAYMENT_SUCCESS_EVENT_NAME, handler);
};

const openPaymentPrompt = ({ eventId, ...rest }) =>
	dispatchBillingEvent({
		type: 'payment_required',
		eventId,
		...rest,
	});

const openUpgradePrompt = (payload) =>
	dispatchBillingEvent({
		type: 'plan_limit_reached',
		...payload,
	});

export {
	BILLING_EVENT_NAME,
	PAYMENT_SUCCESS_EVENT_NAME,
	dispatchBillingEvent,
	dispatchPaymentSuccess,
	subscribeToBillingEvents,
	subscribeToPaymentSuccess,
	openPaymentPrompt,
	openUpgradePrompt,
};
